<template>
  <div>
    <template v-if="match.type==='pointBase'">
      <!-- Status -->
      <BoardStatusRow 
        :reverse="reverse"
        :is-live="match.isLive"
        :is-finish="match.isFinish"
        :last-event="lastEvent"
        :extra-players="extraPlayers" />
      <!-- Active DownTime and Total Score -->
      <v-layout 
        :reverse="reverse"
        row
        no-wrap
        @click.stop="scoreClicked">
        <!-- Local Score -->
        <v-flex :class="match.started?'xs5':'xs6'">
          <v-card 
            :color="getScoreColor('l')" 
            class="display-2" 
            dark>
            {{ match.totalScoreLocal }}
          </v-card>
        </v-flex>
        <!-- Local Score -->
        <v-flex 
          v-if="match.started" 
          xs2 
          class="text-xs-center caption grey--text">
          <v-layout 
            v-for="(set,i) in match.sets" 
            v-if="set.l>0 || set.v>0"
            :key="`setheader_${i}`" 
            :reverse="reverse"
            my-0
            py-0
            wrap 
            row>
            <v-flex 
              :class="!reverse?'text-xs-right':'text-xs-left'"
              xs5 
              my-0 
              py-0>{{ set.l }}</v-flex>
            <v-flex 
              xs2
              my-0
              py-0>-</v-flex>
            <v-flex 
              :class="reverse?'text-xs-right':'text-xs-left'"
              xs5
              my-0
              py-0>{{ set.v }}</v-flex>
          </v-layout>
        </v-flex>
        <!-- Visitor Score -->
        <v-flex :class="match.started?'xs5':'xs6'">
          <v-card 
            :color="getScoreColor('v')" 
            class="display-2"
            dark>
            {{ match.totalScoreVisitor }}
          </v-card>
        </v-flex>
      </v-layout>
      <!-- DownTimes, Set Score and Set number -->
      <v-layout 
        v-if="match.displaySets"
        :reverse="reverse"
        row
        no-wrap>
        <!-- Local Counters -->
        <BoardScoreCounters 
          :counters="match.counters.l"
          :is-finish="match.isFinish"
          :reverse="reverse" />
        <!-- Local Set Score -->
        <v-flex 
          d-flex
          xs3>
          <v-card 
            :class="{blink_me:match.lastPointLocal}"
            color="blue" 
            class="display-2"
            dark>
            <v-layout 
              align-center 
              justify-center>
              <v-card-text>
                {{ match.setScoreLocal }}
              </v-card-text>
            </v-layout>
          </v-card>
        </v-flex>
        <!-- Set Number -->
        <v-flex 
          d-flex
          xs4>
          <v-card
            color="blue"
            class="lighten-5" >
            <v-layout 
              align-center 
              justify-center >
              <v-card-text>
                {{ match.setText }}
                <br>
                <span class="text-bigger">{{ match.setNumber }}</span>
              </v-card-text>
            </v-layout>
          </v-card>
        </v-flex>
        <!-- Visitor Score -->
        <v-flex 
          d-flex
          xs3>
          <v-card 
            :class="{blink_me:match.lastPointVisitor}"
            color="blue" 
            class="display-2"
            dark>
            <v-layout 
              align-center 
              justify-center>
              <v-card-text>
                {{ match.setScoreVisitor }}
              </v-card-text>
            </v-layout>
          </v-card>
        </v-flex>
        <!-- Visitor Counters -->
        <BoardScoreCounters 
          :counters="match.counters.v"
          :is-finish="match.isFinish"
          :reverse="!reverse" />
      </v-layout>
    </template>
    <template v-if="match.type==='timeBase'">
      <!-- Status -->
      <BoardStatusRow 
        :reverse="reverse"
        :is-live="match.isLive"
        :is-finish="match.isFinish"
        :last-event="lastEvent"
        :extra-players="extraPlayers" />
      <!-- DownTimes, Set Score and Set number -->
      <v-layout 
        :reverse="reverse"
        row
        no-wrap
        @click.stop="scoreClicked">
        <!-- Local Counters -->
        <BoardScoreCounters 
          v-if="match.started && !match.isFinish"
          :counters="match.counters.l"
          :is-finish="match.isFinish"
          :reverse="reverse" />
        <!-- Local Score -->
        <v-flex 
          :class="match.started && !match.isFinish?'xs3':'xs6'"
          d-flex>
          <v-card 
            :color="getScoreColor('l')" 
            class="display-2" 
            dark>
            {{ match.totalScoreLocal }}
          </v-card>
        </v-flex>
        <!-- Match Period -->
        <v-flex 
          v-if="match.started && !match.isFinish"
          d-flex
          xs2>
          <v-layout 
            row 
            wrap>
            <v-flex
              d-flex
              xs12 >
              <v-card
                color="blue"
                class="lighten-5 grey--text text--darken-1" >
                <svg 
                  width="80%" 
                  height="100%" 
                  style="max-width:70px"
                  viewBox="0 0 300 100"><text 
                    y="80" 
                    textLength="100%" 
                    lengthAdjust="spacingAndGlyphs" 
                    font-size="100">
                    {{ match.setText }}
                    {{ match.setNumber }}
                  </text>
                </svg>
              </v-card>
            </v-flex>
            <!--
            <v-flex
              d-flex
              xs12 >
              <v-card
                color="blue"
                class="lighten-5 grey--text text--darken-1" >
                {{ timeValue }}
              </v-card>
            </v-flex>
            -->
          </v-layout>
        </v-flex>
        <!-- Visitor Score -->
        <v-flex 
          :class="match.started && !match.isFinish?'xs3':'xs6'"
          d-flex>
          <v-card 
            :color="getScoreColor('v')" 
            class="display-2"
            dark>
            {{ match.totalScoreVisitor }}
          </v-card>
        </v-flex>
        <!-- Visitor Counters -->
        <BoardScoreCounters 
          v-if="match.started && !match.isFinish"
          :counters="match.counters.v"
          :is-finish="match.isFinish"
          :reverse="!reverse" />
      </v-layout>
    </template>
    <template v-if="match.type==='baseballBase'">
      <!-- Status -->
      <BoardStatusRow 
        :reverse="reverse"
        :is-live="match.isLive"
        :is-finish="match.isFinish"
        :last-event="lastEvent"
        :extra-players="extraPlayers" />
      <!-- DownTimes, Set Score and Set number -->
      <v-layout 
        :reverse="reverse"
        row
        no-wrap
        @click.stop="scoreClicked">
        <!-- Local Counters -->
        <BoardScoreCounters 
          :counters="match.counters.l"
          :is-finish="match.isFinish"
          :reverse="reverse" />
        <!-- Local Score -->
        <v-flex 
          :class="{xs3:!match.isFinish, xs5:match.isFinish}"
          d-flex>
          <v-card 
            :color="getScoreColor('l')" 
            class="display-2" 
            dark>
            {{ match.totalScoreLocal }}
          </v-card>
        </v-flex>
        <!-- Innin -->
        <v-flex 
          v-if="!match.isFinish"
          d-flex
          xs4>
          <v-layout 
            row 
            wrap>
            <v-flex
              d-flex
              xs12 >
              <v-card
                color="blue"
                class="lighten-5 grey--text text--darken-1" >
                {{ match.setText }}
                <br>
                {{ match.setNumber }}
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
        <!-- Visitor Score -->
        <v-flex 
          :class="{xs3:!match.isFinish, xs5:match.isFinish}"
          d-flex>
          <v-card 
            :color="getScoreColor('v')" 
            class="display-2"
            dark>
            {{ match.totalScoreVisitor }}
          </v-card>
        </v-flex>
        <!-- Visitor Counters -->
        <BoardScoreCounters 
          :counters="match.counters.v"
          :is-finish="match.isFinish"
          :reverse="!reverse" />
      </v-layout>
    </template>
  </div>
</template>

<script>
import BoardStatusRow from '@/components/Dashboard/Views/Club/Views/WeekMatches/Views/Match/Templates/MatchCard/MatchBoard/Board/BoardStatusRow'
import BoardScoreCounters from '@/components/Dashboard/Views/Club/Views/WeekMatches/Views/Match/Templates/MatchCard/MatchBoard/Board/BoardScoreCounters'
// const debug = require('debug')('OD::BoardScore')

export default {
  name: 'BoardScore',
  components: { BoardStatusRow, BoardScoreCounters },
  props: {
    match: {
      type: Object,
      required: true,
    },
    lastEvent: {
      type: Object,
      default: null,
    },
    extraPlayers: {
      type: Array,
      required: true,
    },
    timeValue: {
      type: String,
      default: '00:00',
    },
    reverse: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {}
  },
  computed: {},
  watch: {},
  created() {},
  beforeDestroy() {},
  methods: {
    scoreClicked() {
      this.$emit('scoreClicked')
    },
    getScoreColor(team) {
      if (this.match.isFinish) {
        if (this.match.totalScoreLocal === this.match.totalScoreVisitor) {
          return 'light-green'
        }
        if (team === 'l') {
          return this.match.totalScoreLocal > this.match.totalScoreVisitor ? 'green' : 'grey'
        }
        return this.match.totalScoreVisitor > this.match.totalScoreLocal ? 'green' : 'grey'
      }
      return 'grey'
    },
  },
}
</script>

<style lang="scss" scoped>
@media (max-width: 600px) {
  .xs-d-block {
    display: block;
  }
}
.logo-container {
  max-width: 100%;
  overflow-y: hidden;
  display: block;
  img {
    max-height: 40px;
  }
}
.uppercase {
  text-transform: uppercase;
}

.team-name {
  text-transform: uppercase;
  font-weight: bold;
  color: grey;
}

.text-bigger {
  font-size: 1.3em;
  font-weight: bold;
}

.tiebreak-icon {
  width: 20px;
}

.blink_me {
  animation: blinker 3s linear infinite;
}

.blink_me_color {
  animation: blinker_color 3s linear infinite;
}

@keyframes blinker {
  50% {
    opacity: 0.4;
  }
}

@keyframes blinker_color {
  50% {
    color: #aaa;
  }
}

.sets-summary {
  th {
    padding: 0 5px;
    background-color: #ddd;
  }
  th.white {
    background-color: #fff;
  }
  td {
    background-color: #f8f8f8;
    text-align: center;
  }
  th.odd,
  td.odd {
    background-color: #f0f0f0;
  }
  th.even,
  td.even {
    background-color: #f8f8f8;
  }
  td.bold {
    font-weight: bold;
  }
}

.table-responsive {
  display: block;
  width: 100%;
  border: 0;
  overflow-x: scroll;
  overflow-y: hidden;
  -ms-overflow-style: -ms-autohiding-scrollbar;
  -webkit-overflow-scrolling: touch;
}

.card__text.small {
  padding: 8px 3px 3px 3px;
}

.rightPanel {
  text-align: left;
  padding: 24px;
}
</style>
